import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from '@env/environment';
import { Game } from '@mtgame/core';

@Component({
  selector: 'mtg-handball-game-documents',
  templateUrl: './handball-game-documents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HandballGameDocumentsComponent {
  @Input()
  game: Game;

  printProtocol(): void {
    window.open(`${environment.apiUrl}/api/v1/tournament_handball_game/${this.game.id}/game_protocol/?file_type=html`);
  }

  printGameApplication(): void {
    window.open(`${environment.apiUrl}/api/v1/tournament_handball_game/${this.game.id}/game_application_file/?file_type=html&application_type=tournament_users`);
  }
}
